import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "@/lib/api";
import { BookCard } from "@/components/BookCard";
import { ArrowLeft, PenTool } from "lucide-react";

export default function Author() {
  const { name } = useParams();
  const yazar = decodeURIComponent(name || "");
  const [books, setBooks] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api.get("/books", { params: { yazar } }).then((r) => setBooks(r.data)).finally(() => setLoading(false));
  }, [yazar]);

  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6 py-8">
      <Link to="/kitaplar" className="flex items-center gap-1 text-sm text-muted-foreground hover:text-terra mb-6"><ArrowLeft size={16} /> Kitaplar</Link>
      <div className="fade-up flex items-center gap-2">
        <PenTool className="text-terra" size={20} />
        <p className="text-xs uppercase tracking-[0.2em] font-bold text-terra">Yazar</p>
      </div>
      <h1 className="font-serif text-4xl sm:text-5xl text-ink tracking-tight mt-1" data-testid="author-name">{yazar}</h1>
      <p className="text-sm text-muted-foreground mt-2">{books.length} kitap</p>

      {loading ? (
        <p className="text-muted-foreground mt-8">Yükleniyor...</p>
      ) : books.length === 0 ? (
        <p className="text-muted-foreground mt-8" data-testid="author-empty">Bu yazara ait kitap bulunamadı.</p>
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-5 mt-6" data-testid="author-books">
          {books.map((b) => <BookCard key={b.id} book={b} />)}
        </div>
      )}
    </div>
  );
}
